import React from 'react';
import { createRoot } from 'react-dom/client';
import { AdminEmailLogDetailPage, type AdminEmailLogDetailPageProps } from '../ui/admin/AdminEmailLogDetailPage';

export function AdminEmailLogDetailPageContainer(props: AdminEmailLogDetailPageProps) {
  return <AdminEmailLogDetailPage {...props} />;
}

export function mountAdminEmailLogDetailPage(
  container: HTMLElement,
  props: AdminEmailLogDetailPageProps
) {
  const root = createRoot(container);
  root.render(<AdminEmailLogDetailPageContainer {...props} />);
  return root;
}

export default AdminEmailLogDetailPageContainer;
